import React from 'react';
import ReactDOM from 'react-dom';
import { Toast } from "../Toast";
export var ToastStatic = function ToastStatic() {};

ToastStatic.push = function (notification, action) {
  if (!ToastStatic.node) {
    ToastStatic.node = document.createElement('div');
    var _document = document,
        body = _document.body;

    if (!body) {
      throw Error('There is no "body" element in "document"');
    }

    body.appendChild(ToastStatic.node);
    ReactDOM.render( /*#__PURE__*/React.createElement(Toast, {
      "data-tid": "StaticToast",
      ref: function ref(el) {
        return ToastStatic.instance = el;
      }
    }), ToastStatic.node, function () {
      return ToastStatic._push(notification, action);
    });
  } else {
    ToastStatic._push(notification, action);
  }
};

ToastStatic._push = function (notification, action) {
  if (ToastStatic.instance) {
    ToastStatic.instance.push(notification, action);
  }
};

ToastStatic.close = function () {
  if (ToastStatic.instance) {
    ToastStatic.instance.close();
  }
};

ToastStatic.node = void 0;
ToastStatic.instance = null;